import IconShareLink from "../components/icons/IconShareLink";
import * as Popover from "@radix-ui/react-popover";
import { useRef, useState } from "react";
import IconCheckCircleChecked from "./icons/IconCheckCircleChecked";

export default function ShareUrl({
  heading,
  text,
  loginToken,
  type,
}: {
  heading: string;
  text: string;
  loginToken: string;
  type: "KKE" | "TE";
}) {
  const [isCopied, setIsCopied] = useState(false);
  // const ref = useRef<HTMLDivElement>(null);
  const ref = useRef(null);
  const link = `${import.meta.env.VITE_BASE_URL ?? ""}/${
    type === "TE" ? "tilsynslink" : "link"
  }/${loginToken}`;
  const copyLink = () => {
    navigator.clipboard.writeText(link).then(() => {
      setIsCopied(true);

      // Reset the copied state after 5 seconds
      setTimeout(() => {
        setIsCopied(false);
      }, 5000);
    });

    if (ref.current) {
      const range = document.createRange();
      const selection = window.getSelection();
      range.selectNodeContents(ref.current);
      selection?.removeAllRanges();
      selection?.addRange(range);
    }
  };

  return (
    <Popover.Root modal>
      <Popover.Trigger asChild>
        <button
          type="button"
          className="btn btn-outline-primary-subtle w-100 py-2 lh-lg d-flex align-items-center gap-2 justify-content-center"
        >
          <IconShareLink /> Invitér ...
        </button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content className="c-popover" align="end">
          <div className="c-popover-content">
            <h3 className="h5 mb-2 lh-sm">{heading}</h3>
            <p className="fs-6">{text}</p>
            <div className="bg-light d-flex p-2">
              <span
                ref={ref}
                className="lh-sm fw-normal small px-2 py-1 text-break flex-grow-1"
              >
                {link}
              </span>
              <button
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2 text-nowrap justify-content-center"
                style={{ minWidth: 130 }}
                onClick={copyLink}
              >
                {isCopied ? (
                  <>
                    <IconCheckCircleChecked height={15} />
                    <span>Kopieret!</span>
                  </>
                ) : (
                  <span>Kopier link</span>
                )}
              </button>
            </div>
            <Popover.Close asChild>
              <button
                type="button"
                className="btn-close btn--circle c-popover-close"
                aria-label="Luk"
              ></button>
            </Popover.Close>
            <Popover.Arrow className="c-popover-arrow" />
          </div>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
